import { defineAsyncComponent } from '../../../lib/utils/vue3compat/vue.js?vue3';
import { GlDrawer } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { DRAWER_Z_INDEX } from '~/lib/utils/constants';
import { getContentWrapperHeight } from '~/lib/utils/dom_utils';
import getMergeRequestReviewers from '~/sidebar/queries/get_merge_request_reviewers.query.graphql';
export default {
    name: 'ReviewerDrawer',
    apollo: {
        reviewers: {
            query: getMergeRequestReviewers,
            variables () {
                return {
                    fullPath: this.projectPath,
                    iid: this.issuableIid
                };
            },
            update: (data)=>data.namespace?.issuable?.reviewers?.nodes || [],
            skip () {
                return !this.open;
            }
        }
    },
    components: {
        GlDrawer,
        ApprovalSummary: defineAsyncComponent(()=>import('ee_component/merge_requests/components/reviewers/approval_summary.vue')),
        ApprovalRulesWrapper: defineAsyncComponent(()=>import('../../../../../../ee/app/assets/javascripts/merge_requests/components/reviewers/approval_rules_wrapper.vue?vue3'))
    },
    inject: [
        'projectPath',
        'issuableIid'
    ],
    props: {
        open: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'close',
        'remove-reviewer',
        'request-review'
    ],
    data () {
        return {
            reviewers: []
        };
    },
    computed: {
        getDrawerHeaderHeight () {
            if (!this.open) return '0';
            return getContentWrapperHeight();
        }
    },
    DRAWER_Z_INDEX
};
